import React, { useState, useEffect } from 'react'
import api from "../api/dataSource"
import {
  Button,
  Card,
  Row,
  Col,
  Table,
  CardText, CardBody, CardLink,
  CardTitle, CardSubtitle
} from 'reactstrap';
import classnames from 'classnames'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'

const Resultados = ({idCampeonato}) => {
  const [tabla, setTabla] = useState([])
  const [goleadores, setGoleadores] = useState([])
  const [tarjetas, setTarjetas] = useState([])
  const [jugadores, setJugadores] = useState([])
  const [esEquipos, setEsEquipos] = useState(true)
  const [currentEquipo, setCurrentEquipo] = useState('')
  const [otrasFases, setOtrasFases] = useState([])
  const MySwal = withReactContent(Swal)

  const getTabla = (ide) => {
    api.getCampeonato(`api/tabla_posiciones_pagina/${ide}`).then((resp) => {
      const lista = []
      const otrasFasesAux = []
      resp.data.forEach((x) => {
        let ganados = 0
        let empatados = 0
        let perdidos = 0
        let puntos = 0
        let jugados = 0
        let golesFavor = 0
        let golesContra = 0
        x.partido.forEach((p) => {
          if (!!p.partido) {
            const esLocal = x.id === p.local
            if (p.fase === 'Grupos') {
              jugados += 1
              const resultado = p.partido.localMarcador === p.partido.visitanteMarcador ? 'empate' : p.partido.localMarcador > p.partido.visitanteMarcador ? 'local' : 'visitante'
              if (resultado === 'empate') {
                empatados += 1
                puntos += 1
                golesFavor += p.partido.localMarcador
                golesContra += p.partido.localMarcador
              } else if (resultado === 'local' && esLocal) {
                ganados += 1
                puntos += 3
              } else if (resultado === 'visitante' && !esLocal) {
                ganados += 1
                puntos += 3
              } else {
                perdidos += 1
              }
              if (resultado !== 'empate') {
                if (esLocal) {
                  golesFavor += p.partido.localMarcador
                  golesContra += p.partido.visitanteMarcador
                } else {
                  golesFavor += p.partido.visitanteMarcador
                  golesContra += p.partido.localMarcador
                }
              }
            } else {
              const ind = otrasFasesAux.findIndex((xxx) => xxx.id === p.partido.id)
              if (ind === -1) {
                otrasFasesAux.push({
                  id: p.partido.id,
                  fase: p.fase,
                  local: esLocal ? x.equipo.nombre : '',
                  visitante: !esLocal ? x.equipo.nombre : '',
                  ...p.partido
                })
              } else {
                otrasFasesAux[ind].local = esLocal ? x.equipo.nombre : otrasFasesAux[ind].local
                otrasFasesAux[ind].visitante = !esLocal ? x.equipo.nombre : otrasFasesAux[ind].visitante
              }
            }
          }
        })
        lista.push({
          nombre: x.equipo.nombre,
          grupo: x.grupo,
          jugados,
          ganados,
          empatados,
          perdidos,
          golesFavor,
          golesContra,
          diferencia: golesFavor - golesContra,
          puntos
        })
      })
      const listEquiposx = {}
      lista.forEach((x) => {
        if (!listEquiposx[x.grupo]) {
          listEquiposx[x.grupo] = [
            {
              ...x
            }
          ]
        } else {
          listEquiposx[x.grupo].push({
            ...x
          })
        }
      })
      setOtrasFases(otrasFasesAux)
      setTabla(listEquiposx)
    }).catch(error => {
      console.log(error)
    })
  }

  const getGoleadores = (ide) => {
    api.getCampeonato(`api/get_goleadores_pagina/${ide}`).then((resp) => {
      const golx = []
      resp.forEach((j) => {
        const jug = j.jugador
        golx.push({
          id: j.jugadorId,
          goles: j.goles,
          equipo: j.equipo[0].nombre,
          jugador: `${jug.nombre} ${jug.apellidoPaterno} ${jug.apellidoMaterno || ''}`
        })
      })
      setGoleadores(golx)
    }).catch(error => {
      console.log(error)
    })
  }

  const getTarjetas = (ide) => {
    api.getCampeonato(`api/get_tarjetas_pagina/${ide}`).then((resp) => {
      setTarjetas(resp)
    }).catch(error => {
      console.log(error)
    })
  }

  const numero = 1
  useEffect(() => {
    getTabla(idCampeonato)
    getGoleadores(idCampeonato)
    getTarjetas(idCampeonato)
  }, [numero])

  return (
    <>
      {
        otrasFases.length > 0
        && (
          <Row>
            <Col sm="12">
              <Card>
                <CardBody>
                  <CardTitle tag="h5">Fases Finales</CardTitle>
                </CardBody>
                <CardBody>
                  <Table bordered responsive size="sm" striped>
                    <thead>
                      <tr>
                        <th>Fase</th>
                        <th>Fecha</th>
                        <th>Hora</th>
                        <th>Local</th>
                        <th>Marcador</th>
                        <th>Visitante</th>
                        <th>Marcador</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        otrasFases.map((f) => (
                          <tr key={f.id}>
                            <td>{f.fase}</td>
                            <td>{f.fecha}</td>
                            <td>{f.hora}</td>
                            <td>{f.local}</td>
                            <td>{f.localMarcador}</td>
                            <td>{f.visitante}</td>
                            <td>{f.visitanteMarcador}</td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )
      }
      <Row>
        {
          Object.entries(tabla).map((tab) => (
            <Col sm="6" key={tab[0]}>
              <Card>
                <CardBody>
                  <CardTitle tag="h5">Grupo {tab[0]}</CardTitle>
                </CardBody>
                <CardBody>
                  <Table bordered responsive size="sm" striped>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Nombre</th>
                        <th>PJ</th>
                        <th>G</th>
                        <th>E</th>
                        <th>P</th>
                        <th>GF</th>
                        <th>GC</th>
                        <th>DG</th>
                        <th>Pts</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        tab[1].sort((a, b) => {
                          if (b.puntos === a.puntos) {
                            return b.diferencia - a.diferencia
                          }
                          return b.puntos > a.puntos ? 1 : -1
                        }).map((x, index) => (
                          <tr key={x.nombre}>
                            <th>{index + 1}</th>
                            <td>{x.nombre}</td>
                            <td>{x.jugados}</td>
                            <td>{x.ganados}</td>
                            <td>{x.empatados}</td>
                            <td>{x.perdidos}</td>
                            <td>{x.golesFavor}</td>
                            <td>{x.golesContra}</td>
                            <td>{x.diferencia}</td>
                            <td>{x.puntos}</td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          ))
        }
      </Row>
      <Row>
        <Col sm="6">
          <Card>
            <CardBody>
              <CardTitle tag="h5">Goleadores</CardTitle>
            </CardBody>
            <CardBody>
              <Table bordered responsive size="sm" striped>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Equipo</th>
                    <th>Jugador</th>
                    <th>Goles</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    goleadores.map((f, index) => (
                      <tr key={f.id}>
                        <th>{(index + 1)}</th>
                        <td>{f.equipo}</td>
                        <td>{f.jugador}</td>
                        <td>{f.goles}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
        <Col sm="6">
          <Card>
            <CardBody>
              <CardTitle tag="h5">Tarjetas</CardTitle>
            </CardBody>
            <CardBody>
              <Table bordered responsive size="sm" striped>
                <thead>
                  <tr>
                    <th>Jugador</th>
                    <th>Tarjeta</th>
                    <th>Cantidad</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    tarjetas.map((f, index) => (
                      <tr key={index}>
                        <td>{f.nombrex}</td>
                        <td>{f.color}</td>
                        <td>{f.cantidad}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default Resultados
